import styled, { css } from "styled-components/native";
import { spacing_m, spacing_s, spacing_xs, white_smoke } from "../../StyleHelpers";
import { Props, GridProps } from "./model";

export const StyledContainer = styled.View`
	width: 100%;
`;

export const StyledTitle = styled.Text<GridProps>`
	font-size: 25px;
	color: ${white_smoke};
	width: 90vw;
	margin: 0 5vw ${spacing_m} 5vw;
	${(props) =>
		props?.isNarrow &&
		css`
			margin: 0 5vw ${spacing_xs} 5vw;
		`}
`;

export const StyledProgressTitle = styled.Text<GridProps>`
	width: 368px;
	height: ${spacing_m};
	border-radius: 16px;
	overflow: hidden;
	margin: 0 5vw ${spacing_m} 5vw;
	${(props) =>
		props?.isNarrow &&
		css`
			margin: 0 5vw ${spacing_xs} 5vw;
		`}
`;

export const StyledGridCenter = styled.View<Props>`
	${(props) =>
		props.isExtras &&
		css`
			margin-bottom: 1.2%;
		`}
`;

export const StyledGrid = styled.View<GridProps>`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	${(props) =>
		props?.gridSize &&
		!props.isNarrow &&
		css`
			grid-template-columns: repeat(${props.gridSize}, 1fr);
			column-gap: ${spacing_m};
			row-gap: ${spacing_m};
		`}

	${(props) =>
		props?.gridSize &&
		props?.isNarrow &&
		css`
			grid-template-columns: repeat(${props.gridSize}, 1fr);
			gap: ${spacing_s};
		`}

    width:  ${(props) => (props.isNarrow && props.isExtras ? "70vw" : "90w")};
	margin: ${(props) => (props.isNarrow && props.isExtras ? "0 0 0 1.5rem" : "0 5vw")};

	${(props) =>
		props?.isNarrow &&
		props?.isStudioAccess &&
		props?.isToggleMQTT &&
		css`
			padding-left: 250px;
		`}
`;

export const StyledImage = styled.View<any>`
	${(props) =>
		props?.isClips &&
		css`
			margin: 0 auto;
		`}

	${(props) =>
		props?.isNarrow &&
		css`
			width: 8.1875rem;
			height: 12.3125rem;
			flex-shrink: 0;
		`}

	${(props) =>
		props?.isNarrow &&
		props.isExtras &&
		css`
			width: 13.75rem;
			flex-direction: column;
			align-items: flex-start;
			gap: 0.5rem;
			display: flex;
		`}

	${(props) =>
		props?.isNarrow &&
		props.isStudioAccess &&
		css`
			width: 13.75rem;
			flex-direction: column;
			align-items: flex-start;
			gap: 0.5rem;
			display: flex;
		`}

	${(props) =>
		props?.isNarrow &&
		props.isClips &&
		css`
			width: 13.75rem;
			flex-direction: column;
			align-items: flex-start;
			gap: 0.5rem;
			display: flex;
		`}
`;
